const PTO_MERGE_FIELDS = [
  {
    key: 'employee_first_name',
    label: 'company_settings.company_email_templates.merge_fields.Employee First Name',
    placeholder: 'company_settings.company_email_templates.merge_fields.#[Employee First Name]'
  },
  {
    key: 'employee_last_name',
    label: 'company_settings.company_email_templates.merge_fields.Employee Last Name',
    placeholder: 'company_settings.company_email_templates.merge_fields.#[Employee Last Name]'
  },
  {
    key: 'current_date',
    label: 'company_settings.company_email_templates.merge_fields.Current Date',
    placeholder: 'company_settings.company_email_templates.merge_fields.#[Current Date]'
  },
  {
    key: 'company_name',
    label: 'company_settings.company_email_templates.merge_fields.Company Name',
    placeholder: 'company_settings.company_email_templates.merge_fields.#[Company Name]'
  }
];

export default PTO_MERGE_FIELDS;
